angular.module('bmsApp.trugreen.job')
	.controller('TGCancelJobModalCtrl',
		function ($state,
				  $modalInstance,
				  $scope,
				  $filter,
				  moment,
				  ConfigService,
				  TGCancelReasonSvc,
				  TGJobSvc,
				  job) {

			var self = this;
			self.cancelReason = undefined;

			self.methods = {
				init: init,
				cancel: cancel,
				submit: submit
			};

			function init() {
				self.job = job;
				TGCancelReasonSvc.options().then(function(response) {
					self.cancelReasons = response.data.options;
				});
			}

			function submit() {
				var params = {
					jobId: self.job.id,
					cancelReason: self.cancelReason
				};
				return TGJobSvc.cancelJob(params).then(function(response) {
					$modalInstance.close(response.data.tg_job);
				}, function(errors) {
					self.errors = errors;
				});
			}

			function cancel() {
				$modalInstance.dismiss('cancel');
			}
		});